import React__default, { useState, useEffect } from 'react';
import classNames from 'classnames';

const BVRatings = (props) => {
    const { variantSKU, WidgetType = "inline_rating", className = "", style = {}, preserveInitialSKU = false } = props;
    const [sku, setSku] = useState(variantSKU);
    useEffect(() => {
        if (preserveInitialSKU)
            return;
        setSku(variantSKU);
    }, [variantSKU]);
    if (!sku)
        return React__default.createElement(React__default.Fragment, null);
    return React__default.createElement("div", { "data-bv-show": WidgetType, className: classNames("bazaar-ratings", WidgetType, className), "data-bv-product-id": sku, style: style });
};

export { BVRatings };
//# sourceMappingURL=BVRatings.js.map
